import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import { localizeHref } from "components/store/source";

import Text from "./Text";

import styles from "./Link.module.scss";

function Link({
  translateKey,
  text,
  textElement,
  textTypes,
  href,
  className,
  red,
  dark,
  grey,
  white,
  darkButton,
  lightButton,
  outlinedButtonDark,
  navButton,
  target,
  underline,
  onClick,
  inline,
  wordWrap,
  children,
  newTab,
  useLocalizedHref,
  ...props
}) {
  const classNames = classnames(styles.base, className, {
    [styles.red]: red,
    [styles.grey]: grey,
    [styles.white]: white,
    [styles.dark]: dark,
    [styles.dark_button]: darkButton,
    [styles.light_button]: lightButton,
    [styles.outlined_button_dark]: outlinedButtonDark,
    [styles.nav_button]: navButton,
    [styles.underline]: underline,
    [styles.wordWrap]: wordWrap,
    [styles.inline]: inline,
  });

  const linkTarget = newTab ? "_blank" : target;

  const localizedHref = useLocalizedHref ? localizeHref(href) : href;

  if (text || translateKey) {
    return (
      <a
        className={classNames}
        href={localizedHref}
        onClick={onClick}
        target={linkTarget}
        {...props}
      >
        {translateKey ? (
          <Text
            element={textElement}
            translateKey={translateKey}
            types={textTypes}
          />
        ) : (
          <Text element={textElement} types={textTypes}>
            {text}
          </Text>
        )}
      </a>
    );
  }
  return (
    <a
      className={classNames}
      href={localizedHref}
      onClick={onClick}
      target={linkTarget}
      {...props}
    >
      {children}
    </a>
  );
}

Link.propTypes = {
  translateKey: PropTypes.string,
  text: PropTypes.string,
  textTypes: PropTypes.array,
  textElement: PropTypes.string,
  className: PropTypes.string,
  dark: PropTypes.bool,
  darkButton: PropTypes.bool,
  lightButton: PropTypes.bool,
  outlinedButtonDark: PropTypes.bool,
  navButton: PropTypes.bool,
  red: PropTypes.bool,
  grey: PropTypes.bool,
  white: PropTypes.bool,
  underline: PropTypes.bool,
  inline: PropTypes.bool,
  target: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  wordWrap: PropTypes.bool,
  newTab: PropTypes.bool,
  useLocalizedHref: PropTypes.bool,
};

Link.defaultProps = {
  translateKey: null,
  text: null,
  textTypes: [],
  textElement: undefined,
  onClick: null,
  className: null,
  dark: false,
  darkButton: false,
  lightButton: false,
  outlinedButtonDark: false,
  red: false,
  grey: false,
  white: false,
  underline: false,
  inline: false,
  href: null,
  children: null,
  target: "_self",
  newTab: false,
  wordWrap: false,
  useLocalizedHref: true,
};

export default Link;
